import { render, staticRenderFns } from "./Timeline-item.vue?vue&type=template&id=27aed417&scoped=true"
import script from "./Timeline-item.vue?vue&type=script&lang=js"
export * from "./Timeline-item.vue?vue&type=script&lang=js"
import style0 from "./Timeline-item.vue?vue&type=style&index=0&id=27aed417&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aed417",
  null
  
)

export default component.exports